/* eslint-disable */

import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';

import HeaderLogo from '@/assets/images/icons/MFO-main-logo-White.svg';

import styles from '../../../styles/mlp-landing.module.css';
import { useEffect, useState } from 'react';

export const MLPHeader = () => {
  const router = useRouter();
  const [disableDownloadCta, setDisbaleDownloadCta] =  useState(true);
  const [disableUtmSources , setDisableUtmSources] = useState(new Set());
  const [enableHeaderLink , setEnableHeaderLink] = useState(true);
  useEffect(()=>{
    setDisableUtmSources(disableUtmSources.add("phonepe"))
    const { isVisible, utm_source } = router.query
    setDisbaleDownloadCta(isVisible == "false" ? false : true)
    setEnableHeaderLink(utm_source && !Array.isArray(utm_source) && disableUtmSources.has(utm_source) ? false : true);
  },[router.isReady])
  return (
    <>
      <nav
        className={`mainNav navbar fixed-top navbar-expand-lg bg-scroll ${styles['']}`}
        // style={{ position: 'relative', top: '0%', fontFamily: 'Helvetica' }}
      >
        <div className="container">
          <div className="nav-right">
            <Link className="navbar-brand" href={!enableHeaderLink ? "javascript:void(0)" : "/"} id="mlp_muthoot-logo">
              <Image
                style={{ color: undefined }}
                className="img-fluid mfo-logo-header"
                src={HeaderLogo}
                alt="Muthoot Logo"
              />
              <span className="sr-only">Muthoot Logo</span>
            </Link>
          </div>

          <div>
            {disableDownloadCta && (
              <a
                href="https://qrco.de/mfone"
                target="_blank"
                className={`${styles['mlp-downloand-app']} ${styles['mlp-text-bold']} ${styles['mlp-blue-color']}`}
              >
                {/* TODO: Add link */}
                Download the App
              </a>
            )}
          </div>
        </div>
      </nav>
    </>
  );
};
